module.exports = __webpack_public_path__ + "static/media/bride-1-min.7a6e10e9.jpg";